import { render } from "./FirstView.vue?vue&type=template&id=3b90b377&scoped=true"
const script = {}

import "./FirstView.vue?vue&type=style&index=0&id=3b90b377&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b90b377"]])

export default __exports__